export const isReportBackendWidget = (widget) => widget && "dashboard_widget_id" in widget && !("id" in widget);
export const isAvailableWidgetPreview = (widget) => "id" in widget && !("dashboard_widget_id" in widget);
export const isWeeklyFrequency = (schedulingFrequency) => schedulingFrequency.frequency === "WEEKLY";
export const isMonthlyFrequency = (schedulingFrequency) => schedulingFrequency.frequency === "MONTHLY";
